<template>
  <div>
    <div class="cart-container" :style="`top: ${offsetY}px; height: ${cartContainerHeight}px`">
      <div class="cart-header" :style="`padding-bottom: ${this.toggle === false ? cartHeaderPaddingBottom: '0'}px`">
        <button type="button" class="toggle" @click='toggleCart'>
        <span class="state-icon">
          <img
            :src="require('@/assets/img/coupon-with-cart/cart-state-arrow-icon.svg')"
            :class="toggle ? 'open' : 'close'"
            alt=""
          />
        </span>
        <span class="label">
          選択したクーポン： {{ selectedCoupons.length }} 枚
        </span>
        </button>
        <button type="button" class="use" @click="showConfirmDialog" :disabled="selectedCoupons.length < 1">
          クーポンを利用
        </button>
      </div>
      <div class="cart-body" :style="{ height: `${cartBodyHeight}px` }">
        <div class="card-container">
          <div v-for="(coupon, i) in selectedCoupons" :key="i" class="card">
            <div class="left">
              <div class="thumbnail">
                <img :src="coupon.data.thumb_url" alt="" />
              </div>
              {{ coupon.data.caption }}
            </div>
            <div class="right">
              <button type="button" @click="removeCouponFromCart(coupon)">
                <img
                  :src="require('@/assets/img/coupon-with-cart/cart-remove-coupon-icon.svg')"
                  alt=""
                />
                選択解除
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coupon-with-cart-dialog
      key="confirmDialog"
      ref="confirmDialog"
      positive-button-label="利用する"
      negative-button-label="今はやめる"
      @positive="useCouponsOnCart"
      @negative="closeConfirmDialog"
    />
    <template v-if="hasUseError">
      <error-popup
        :error-list="errors"
        :label="'閉じる'"
        @submit="clearError"
        @close="clearError"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CouponWithCartDialog from '@/views/CouponWithCart/Dialog.vue'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import DateFormatter from '@/utils/DateFormatter'
import { COUPON_SELECT_TYPE } from '@/store/couponWithCart'
import '@/styles/color.css'

export default {
  name: 'CouponWithCartCart',
  components: { ErrorPopup, CouponWithCartDialog },
  props: {
    cartHeaderPaddingBottom: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      apiTypeCoupon: '5',
      apiTypePrize: '6',
      toggle: false,
      headerHeight: 60,
      cartBodyHeight: 0,
      cartContainerHeight: window.innerHeight * 0.3,
      offsetY: window.innerHeight,
      errors: []
    }
  },
  mounted() {
    this.offsetY = this.computedOffsetY
    this.cartBodyHeight = this.cartContainerHeight - this.headerHeightWithPaddingBottom
  },
  computed: {
    ...mapGetters({
      selectedCoupons: 'CouponWithCart/selectedCoupons',
      selectedType: 'CouponWithCart/selectedType'
    }),
    computedOffsetY() {
      return this.selectedCoupons.length > 0 ? window.innerHeight - this.headerHeightWithPaddingBottom : window.innerHeight + this.headerHeightWithPaddingBottom
    },
    hasUseError() {
      return this.errors.length > 0
    },
    headerHeightWithPaddingBottom() {
      return this.headerHeight + this.cartHeaderPaddingBottom
    }
  },
  watch: {
    selectedCoupons() {
      if (!this.toggle) {
        this.offsetY = this.computedOffsetY
      } else {
        if (this.selectedCoupons.length < 1) {
          this.offsetY = this.computedOffsetY
          this.toggle = false
        }
      }
    },
    toggle(needsLock) {
      document.body.className = needsLock ? 'scroll-lock' : ''
    }
  },
  methods: {
    ...mapActions('CouponWithCart', [
      'removeFromSelectedCoupon',
      'clearSelectedCoupons',
      'useCoupons'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', ['actionRequestToken']),
    toggleCart() {
      this.toggle = !this.toggle
      this.offsetY = this.toggle ?
        window.innerHeight - this.cartContainerHeight :
        window.innerHeight - this.headerHeightWithPaddingBottom
    },
    removeCouponFromCart(coupon) {
      this.removeFromSelectedCoupon(coupon)
    },
    clearCart() {
      this.clearSelectedCoupons()
    },
    showConfirmDialog() {
      if (!this.toggle) {
        this.toggleCart()
      }
      this.$emit('before-use-coupons')

      let content = '<div style="text-align: center">選択中のクーポンまたはフリーパスを全て利用してよろしいですか？</div>'
      if (this.selectedType === COUPON_SELECT_TYPE.gift) {
        content = '<div style="text-align: center">選択中のクーポンを利用してよろしいですか？<br /><span style="color: #e03535">（外部サービスに遷移した時点で利用済みとなります。）</span></div>'
      }
      this.$refs.confirmDialog.show({
        title: '利用のご確認',
        content,
        isHtmlDisplay: true
      })
    },
    async useCouponsOnCart() {
      this.$refs.confirmDialog.close()

      const accTime = new DateFormatter().format(new Date())

      const buildTokenParams = () => {
        let tokenParams = {
          is_weborder: this.selectedType === COUPON_SELECT_TYPE.joynet ? '1' : '0',
          acc_time: accTime
        }
        let giftType = null

        if (this.selectedType === COUPON_SELECT_TYPE.eatIn) {
          const couponIds = this.selectedCoupons.map((c) => {
            return c.data.coupon_id || c.data.prize_id
          }).join(',')
          tokenParams = {
            ...tokenParams,
            apiType: this.apiTypeCoupon,
            coupon_id: couponIds
          }
        } else {
          const giftPrize = this.selectedCoupons.find((c) => {
            return c.data.type === '1' && c.data.prize_id
          })
          const giftCoupon = this.selectedCoupons.find((c) => {
            return c.data.type === '1' && c.data.coupon_id
          })

          if (giftPrize) {
            tokenParams = {
              ...tokenParams,
              apiType: this.apiTypePrize,
              prize_id: giftPrize.data.prize_id.split('-')[1]
            }
            giftType = giftPrize.data.prize_id.split('-')[0]
          } else if (giftCoupon) {
            tokenParams = {
              ...tokenParams,
              apiType: this.apiTypeCoupon,
              coupon_id: giftCoupon.data.coupon_id.split('-')[1]
            }
            giftType = giftCoupon.data.coupon_id.split('-')[0]
          }
        }
        return { tokenParams, giftType }
      }

      const useCoupons = async ({ token, userId, accTime, couponIds, giftType, giftId, isWebOrder }) => {
        this.actionToggleLoading(true)
        this.$emit('start-use-coupons')
        try {
          const res = await this.useCoupons({ token, userId, accTime, couponIds, giftType, giftId, isWebOrder })
          this.actionToggleLoading(false)

          this.$emit('finish-use-coupons')

          if (res.giftUrl) {
            this.openExternalUrl(res.giftUrl)
          }
          if (res.webOrderUrl) {
            this.openExternalUrl(res.webOrderUrl)
          }
        } catch (e) {
          this.actionToggleLoading(false)
          this.errors = e
        }
      }

      const { tokenParams, giftType } = buildTokenParams()

      window.receivedToken = async (payload) => {
        const json = JSON.parse(payload)
        if (this.selectedType === COUPON_SELECT_TYPE.eatIn || this.selectedType === COUPON_SELECT_TYPE.joynet) {
          await useCoupons({
            token: json.app_token,
            userId: json.user_id,
            accTime,
            couponIds: json.coupon_id,
            giftType: null,
            giftId: null,
            isWebOrder: json.is_weborder
          })
        } else {
          await useCoupons({
            token: json.app_token,
            userId: json.user_id,
            accTime,
            couponIds: null,
            giftType: giftType,
            giftId: json.coupon_id || json.prize_id,
            isWebOrder: json.is_weborder
          })
        }
      }

      this.actionRequestToken(tokenParams)
      // FIXME: for development
      // await useCoupons({
      //   token: 'a',
      //   accTime,
      //   userId: '89a1636f6b85c0d7',
      //   couponIds: tokenParams.coupon_id,
      //   giftType: null,
      //   giftId: null,
      //   isWebOrder: tokenParams.is_weborder
      // })
    },
    hideCart() {
      this.toggle = false
      this.offsetY = this.computedOffsetY
    },
    closeConfirmDialog() {
      this.$refs.confirmDialog.close()
    },
    clearError() {
      this.errors = []
    },
    openExternalUrl(url) {
      this.$emit('open-external-url', url)
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-container {
  width: 100%;
  position: fixed;
  background: #ffffff;
  box-shadow: 0px -1px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px 8px 0;
  transition: top 0.2s 0s ease-in-out;
  z-index: 3;

  .cart-header {
    display: flex;
    align-items: center;

    .toggle {
      padding: 20px 15px;
      width: 100%;
      display: flex;
      color: #000000;
      font-weight: bold;
      font-size: 14px;
      align-items: center;

      .state-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        background: #000000;
        border-radius: 20px;
        margin-right: 8px;
        flex-shrink: 0;
        flex-grow: 0;

        img {
          transition: transform 0.2s 0s ease-in-out;

          &.close {
            transform: rotate(180deg);
          }
        }
      }
    }

    .label {
      flex-shrink: 0;
      font-size: unquote("min(3.5vw, 14px)");
    }

    .use {
      flex-shrink: 0;
      margin: 12px 15px 12px 0;
      background: var(--accent-color);
      padding: 8px;
      color: #ffffff;
      font-weight: bold;
      border-radius: 6px;
      font-size: unquote("min(3.5vw, 14px)");
    }
  }

  .cart-body {
    padding: 0 15px;
    overflow: scroll;
    border-top: 1px solid #cccccc;

    .card-container {
      padding-bottom: 44px;

      .card {
        border-bottom: 1px solid #cccccc;
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: bold;
          color: #000000;
          margin-right: 10px;
          text-align: left;

          .thumbnail {
            flex-shrink: 0;
            width: 55px;
            margin-right: 10px;

            img {
              width: 100%;
            }
          }
        }

        .right {
          flex-shrink: 0;

          button {
            border-bottom: 1px solid #000000;
            display: flex;
            align-items: center;
            color: #000000;

            img {
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}
</style>
